import React from 'react';
import Scroll from 'react-scroll';
import Icon from '../Helper/Icon';

const scroll = Scroll.animateScroll;

/**
 * scrolls up the application
 */
const ScrollUp = () => {
    return (
        <div className="button button--light button--isSquare" onClick={() => scroll.scrollToTop()}>
            <Icon name="arrow-up" isCollapsed={true} />
        </div>
    );
};

export default ScrollUp;